import React from "react";
import { largeVideoModal, ModalVideo } from "../booths/common";
export var getColumn = function (columnOffset, width) {
    if (columnOffset === void 0) { columnOffset = 6.4; }
    if (width === void 0) { width = 28; }
    var curTop = 7;
    return {
        getRow: function (_a) {
            var _b = _a.height, height = _b === void 0 ? 3.8 : _b, label = _a.label, modal = _a.modal;
            var res = {
                width: "".concat(width, "%"),
                height: "".concat(height, "%"),
                left: "".concat(columnOffset, "%"),
                top: "calc(".concat(curTop, "% + 1px)"),
                modalOverrides: largeVideoModal,
                modal: React.createElement(ModalVideo, { url: modal }),
                label: label
            };
            curTop = curTop + height;
            return res;
        }
    };
};
